import ButtonPage from "../../Pages/Buttons/index";
import AccordionsPage from "../../Pages/Accordions/index";
import ListsPage from "../../Pages/Lists/index";
import ModalsPage from "../../Pages/Modals/index";
import FootersPage from "../../Pages/Footers/index";
import BadgesPage from "../../Pages/Badges/index";
import CarouselsPage from "../../Pages/Carousel/index";
import ImagesPage from "../../Pages/Images/index";
import SpinnersPage from "../../Pages/Spinners/index";
import CardsPage from "../../Pages/Cards/index";
import TypographyPage from "../../Pages/Typography/index";
import PagesResourcesPage from "../../Pages/PagesResources/index";
import ProgressBarsPage from "../../Pages/ProgressBar/index";
import ComponentLibraryPage from "../../Pages/ComponentLibrary/index";
import BannerAlertPage from "../../Pages/BannerAlert/index";
import ConfirmationDialogPage from "../../Pages/ConfirmationDialog/index";
import ErrorBoundaryPage from "../../Pages/ErrorBoundary/index";
import WarningCardPage from "../../Pages/WarningCard/index";
import SuccessMessagePage from "../../Pages/SuccessMessage/index";
import LoadingStatePage from "../../Pages/LoadingState/index";
import ToastStackPage from "../../Pages/ToastStack/index";
import HelpTooltipPage from "../../Pages/HelpTooltip/index";
import InputFieldPage from "../../Pages/InputField/index";
import SelectDropdownPage from "../../Pages/SelectDropdown/index";
import CheckboxGroupPage from "../../Pages/CheckboxGroup/index";
import RadioButtonPage from "../../Pages/RadioButton/index";
import TextAreaPage from "../../Pages/TextArea/index";
import FormLabelPage from "../../Pages/FormLabel/index";
import FormErrorPage from "../../Pages/FormError/index";
import InputCounterPage from "../../Pages/InputCounter/index";
import BreadcrumbsPage from "../../Pages/Breadcrumbs/index";
import StickyHeaderPage from "../../Pages/StickyHeader/index";
import SideMenuPage from "../../Pages/SideMenu/index";
import MobileMenuPage from "../../Pages/MobileMenu/index";
import ContextMenuPage from "../../Pages/ContextMenu/index";
import ScrollIndicatorPage from "../../Pages/ScrollIndicator/index";
import DataTablePage from "../../Pages/DataTable/index";
import ChartCardPage from "../../Pages/ChartCard/index";
import StatBoxPage from "../../Pages/StatBox/index";
import TimelinePage from "../../Pages/Timeline/index";
import BadgeLabelPage from "../../Pages/BadgeLabel/index";
import CounterDisplayPage from "../../Pages/CounterDisplay/index";
import BlockQuotePage from "../../Pages/BlockQuote/index";
import CodeBlockPage from "../../Pages/CodeBlock/index";
import TextBlockPage from "../../Pages/TextBlock/index";
import MediaCaptionPage from "../../Pages/MediaCaption/index";
import ArticlePreviewPage from "../../Pages/ArticlePreview/index";
import ContentCardPage from "../../Pages/ContentCard/index";
import SidebarPage from "../../Pages/Sidebar/index";
import ModalDialogPage from "../../Pages/ModalDialog/index";
import DropdownMenuPage from "../../Pages/DropdownMenu/index";
import NotificationPanelPage from "../../Pages/NotificationPanel/index";
import FullscreenViewPage from "../../Pages/FullscreenView/index";
import ImageCardPage from "../../Pages/ImageCard/index";
import VideoPlayerPage from "../../Pages/VideoPlayer/index";
import GalleryModalPage from "../../Pages/GalleryModal/index";
import AccordionPanelPage from "../../Pages/AccordionPanel/index";
import TabPanelPage from "../../Pages/TabPanel/index";
import CarouselWindowPage from "../../Pages/CarouselWindow/index";
import TooltipOverlayPage from "../../Pages/TooltipOverlay/index";
import CartItemPage from "../../Pages/CartItem/index";
import CheckoutStepPage from "../../Pages/CheckoutStep/index";
import UserProfilePage from "../../Pages/UserProfile/index";

import Home from "../../Pages/Home/Home";
import { Redirect, Route, Switch } from "wouter";

const Main = () => {
	return (
		<main className="pl-24 md:pl-80 pr-3 md:pr-6 pb-12 pt-8 md:pt-12 min-h-screen page-transition">
			<Switch>
				<Route path="/" exact component={Home} />
				<Route path="/ComponentLibrary" component={ComponentLibraryPage.page} />
				<Route path="/Buttons" component={ButtonPage.page} />
				<Route path="/Accordions" component={AccordionsPage.page} />
				<Route path="/Lists" component={ListsPage.page} />
				<Route path="/Modals" component={ModalsPage.page} />
				<Route path="/Footers" component={FootersPage.page} />
				<Route path="/Badges" component={BadgesPage.page} />
				<Route path="/Carousels" component={CarouselsPage.page} />
				<Route path="/Carousel">
					<Redirect to="/Carousels" />
				</Route>
				<Route path="/Images" component={ImagesPage.page} />
				<Route path="/Spinners" component={SpinnersPage.page} />
				<Route path="/Cards" component={CardsPage.page} />
				<Route path="/Typography" component={TypographyPage.page} />
				<Route path="/PagesResources" component={PagesResourcesPage.page} />
				<Route path="/Pages-resources">
					<Redirect to="/PagesResources" />
				</Route>
				<Route path="/ProgressBar" component={ProgressBarsPage.page} />
				<Route path="/Progress-bar">
					<Redirect to="/ProgressBar" />
				</Route>
				<Route path="/BannerAlert" component={BannerAlertPage.page} />
				<Route path="/ConfirmationDialog" component={ConfirmationDialogPage.page} />
				<Route path="/ErrorBoundary" component={ErrorBoundaryPage.page} />
				<Route path="/WarningCard" component={WarningCardPage.page} />
				<Route path="/SuccessMessage" component={SuccessMessagePage.page} />
				<Route path="/LoadingState" component={LoadingStatePage.page} />
				<Route path="/ToastStack" component={ToastStackPage.page} />
				<Route path="/HelpTooltip" component={HelpTooltipPage.page} />
				<Route path="/InputField" component={InputFieldPage.page} />
				<Route path="/SelectDropdown" component={SelectDropdownPage.page} />
				<Route path="/CheckboxGroup" component={CheckboxGroupPage.page} />
				<Route path="/RadioButton" component={RadioButtonPage.page} />
				<Route path="/TextArea" component={TextAreaPage.page} />
				<Route path="/FormLabel" component={FormLabelPage.page} />
				<Route path="/FormError" component={FormErrorPage.page} />
				<Route path="/InputCounter" component={InputCounterPage.page} />
				<Route path="/Breadcrumbs" component={BreadcrumbsPage.page} />
				<Route path="/StickyHeader" component={StickyHeaderPage.page} />
				<Route path="/SideMenu" component={SideMenuPage.page} />
				<Route path="/MobileMenu" component={MobileMenuPage.page} />
				<Route path="/ContextMenu" component={ContextMenuPage.page} />
				<Route path="/ScrollIndicator" component={ScrollIndicatorPage.page} />
				<Route path="/DataTable" component={DataTablePage.page} />
				<Route path="/ChartCard" component={ChartCardPage.page} />
				<Route path="/StatBox" component={StatBoxPage.page} />
				<Route path="/Timeline" component={TimelinePage.page} />
				<Route path="/BadgeLabel" component={BadgeLabelPage.page} />
				<Route path="/CounterDisplay" component={CounterDisplayPage.page} />
				<Route path="/BlockQuote" component={BlockQuotePage.page} />
				<Route path="/CodeBlock" component={CodeBlockPage.page} />
				<Route path="/TextBlock" component={TextBlockPage.page} />
				<Route path="/MediaCaption" component={MediaCaptionPage.page} />
				<Route path="/ArticlePreview" component={ArticlePreviewPage.page} />
				<Route path="/ContentCard" component={ContentCardPage.page} />
				<Route path="/Sidebar" component={SidebarPage.page} />
				<Route path="/ModalDialog" component={ModalDialogPage.page} />
				<Route path="/DropdownMenu" component={DropdownMenuPage.page} />
				<Route path="/NotificationPanel" component={NotificationPanelPage.page} />
				<Route path="/FullscreenView" component={FullscreenViewPage.page} />
				<Route path="/ImageCard" component={ImageCardPage.page} />
				<Route path="/VideoPlayer" component={VideoPlayerPage.page} />
				<Route path="/GalleryModal" component={GalleryModalPage.page} />
				<Route path="/AccordionPanel" component={AccordionPanelPage.page} />
				<Route path="/TabPanel" component={TabPanelPage.page} />
				<Route path="/CarouselWindow" component={CarouselWindowPage.page} />
				<Route path="/TooltipOverlay" component={TooltipOverlayPage.page} />
				<Route path="/CartItem" component={CartItemPage.page} />
				<Route path="/CheckoutStep" component={CheckoutStepPage.page} />
				<Route path="/UserProfile" component={UserProfilePage.page} />
			</Switch>
		</main>
	);
};

export default Main;


